@if (isPristine) {
  <button
    (click)="testClick.emit()"
    [blazeButton]="showValidation && isNotTested ? 'warn' : 'primary'"
    [disabled]="!valid"
    [matTooltipDisabled]="!isNotTested"
    blazeTooltip='Blaze needs to know the type of data this action returns. To use this action, you must run "TEST" on it at least once.'
    class="button"
    matTooltipClass="api-builder-tooltip"
    matTooltipPosition="above"
    type="button"
  >
    TEST
    @if (isNotTested) {
      <mat-icon class="icon-16" svgIcon="icon_warning_16" />
    }
  </button>
}

@if (isInProgress) {
  <button type="button" blazeButton class="button"> TESTING </button>
}

@if (isSuccess) {
  <button type="button" blazeButton="success" class="button" (click)="testClick.emit()">
    TEST
    <mat-icon class="icon-16" svgIcon="icon_check_24" />
  </button>
}

@if (isConfirmed) {
  <button type="button" blazeButton="success" class="button" (click)="testClick.emit()">
    <mat-icon class="icon-16" svgIcon="icon_check_24" />
  </button>
}

@if (isError) {
  <button type="button" blazeButton="warn" class="button" (click)="testClick.emit()">
    <mat-icon class="icon-16" svgIcon="icon_warning_24" />
  </button>
}
